import './traces'
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './state/AuthContext';
import { Provider } from 'react-redux';
import store from './state/store/Store';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme/theme';

const isDevelopment = process.env.NODE_ENV === 'development'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_KEY}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {isDevelopment && <React.StrictMode>
        <Provider store={store}>
          <AuthProvider>
            <App />
          </AuthProvider>
        </Provider>
      </React.StrictMode>
      }

      {!isDevelopment && <Provider store={store}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </Provider>
      }
    </ThemeProvider>
  </GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
